/**
 * Reads a value substituted at build time via esbuild's `define` option
 * (e.g. `--define.DEPLOY_URL=...`). esbuild only replaces statically
 * referenced identifiers, so each caller must still declare its own
 * `declare const X` and pass a getter that returns it — outside of a
 * build where the define ran, referencing that identifier throws a
 * `ReferenceError`, which this helper catches and falls back from.
 */
function missing<T>(fallback: T, varName?: string): T {
  if (varName) {
    console.warn(
      `${varName} is not defined. Please set it in your environment variables.`,
    );
  }

  return fallback;
}

export function readBuildTimeVar<T>(
  read: () => T | undefined,
  fallback: T,
  varName?: string,
): T {
  try {
    const value = read();
    return typeof value === 'undefined' ? missing(fallback, varName) : value;
  } catch {
    return missing(fallback, varName);
  }
}
